import { useForm } from "react-hook-form";
import { BienInmueble } from "../../../models/ficha/BienInmueble";
import { InputComponent } from "../../../components/InputComponent";
import { InmuebleService } from "../../../service/ficha/InmuebleService";
import { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { GenericComponent } from "../../../components/GenericComponent";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { Column } from "primereact/column";
import { TablaDinamica } from "../../../components/TablaDinamica";
import { useLazyParams } from "../../../hooks/useLazyParams";

export const Inmueble = ({ tipo, id, toast, permss, num = 11, soloLectura, tipoFrmEmpresa }) => {

    const generic = new GenericComponent();
    const omodel = new BienInmueble();
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const inmuebleService = new InmuebleService();
    const [dialogInmueble, setDialogInmueble] = useState(false);
    const [registroSeleccionado, setRegistroSeleccionado] = useState(null);
    const [load, setLoad] = useState(false);
    const menuRef = useRef(null);
    const tablaInmueble = useLazyParams({ modelo: omodel.model });
    const { inText, inNumber, inCalendar } = InputComponent({ registers: tablaInmueble.data, omodel, generic, errors, control, permss, id: getValues('id'), soloLectura });

    useEffect(() => {
        if (id) loadLazyInmueble();
        // eslint-disable-next-line
    }, [tablaInmueble.lazyParams, id]);

    const loadLazyInmueble = () => {
        tablaInmueble.setLoading(true);
        const _params = { ...tablaInmueble.lazyParams, idp: id, tipo: tipo };
        inmuebleService.lista({ lazyEvent: JSON.stringify(_params) }).then(res => {
            tablaInmueble.setTotalRecords(res.data.total);
            tablaInmueble.setData(res.data.registros);
        }).finally(() => tablaInmueble.setLoading(false));
    }

    const openNew = () => {
        reset(defaultValues);
        setDialogInmueble(true);
    }

    const onSubmit = (data) => {
        data.idp = id;
        data.tipo = tipo;
        setLoad(true);

        const request = getValues('id') == null ? inmuebleService.nuevo(data) : inmuebleService.editar(data);
        request.then(res => {
            setDialogInmueble(false);
            loadLazyInmueble();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => {
            setLoad(false);
        });
    }

    const onError = (errors) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Por favor complete los campos requeridos', life: 3000 });
    }

    const editInmueble = (data) => {
        inmuebleService.consultar(data.id).then(res => {
            reset(res.data.inmueble);
            setDialogInmueble(true);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        });
    }

    const itemsMenu = () => {
        if (soloLectura) {
            return [{ label: 'Opciones', items: [{ label: 'Ver detalle', icon: 'pi pi-eye', command: () => editInmueble(registroSeleccionado) }] }];
        }

        const items = [];
        if (permss?.actualizar)
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => editInmueble(registroSeleccionado) });

        return [{ label: 'Opciones', items: items }];
    }

    const accionesTemplate = (rowData) => (
        <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" aria-controls="popup_menu_inmueble" aria-haspopup onClick={(e) => { setRegistroSeleccionado(rowData); menuRef.current.toggle(e); }} />
    );

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '4rem', textAlign: 'center' }} frozen alignFrozen="right" />
    );

    const cabeceraTabla = () => (
        <div className="flex align-items-center justify-content-start gap-3 py-1">
            {permss?.crear && !soloLectura && tablaInmueble.totalRecords <= 0 && (
                <Button icon="pi pi-plus" className="p-button-rounded p-button-success" type="button" onClick={openNew} title="Registrar información" />
            )}
            <span className="font-bold">Bien Inmueble:</span>
        </div>
    );

    return (
        <>
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu_inmueble" />
            <TablaDinamica modelo={omodel.model} estadoTabla={tablaInmueble} datos={tablaInmueble.data} totalRegistros={tablaInmueble.totalRecords} dataKey="id" acciones={ColumnaAcciones} header={cabeceraTabla()} />

            <Dialog visible={dialogInmueble} header={soloLectura ? "Ver Bien Inmueble" : (getValues('id') == null ? "Nuevo Bien Inmueble" : "Editar Bien Inmueble")} modal className="p-fluid modal-ssize"
                style={{ width: '750px' }} onHide={e => setDialogInmueble(false)}>
                <form onSubmit={(e) => { e.stopPropagation(); handleSubmit(onSubmit, onError)(e); }}>
                    <div className="col-12 mb-3">
                        <div className="flex align-items-center">
                            <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                <i className="pi pi-home text-primary"></i>
                                BIEN INMUEBLE
                            </span>
                            <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                        </div>
                    </div>
                    <div className="formgrid grid">
                        {inText('proyecto', { icon: 'pi pi-building' }, 6)}
                        {inText('modelo', { icon: 'pi pi-tag' }, 6)}
                        {inText('codigo_catastral', { icon: 'pi pi-map' }, 4)}
                        {inText('manzana', { icon: 'pi pi-th-large' }, 4)}
                        {inText('numero_solar', { icon: 'pi pi-hashtag' }, 4)}
                        {inNumber('area_terreno', 2, false, { icon: 'pi pi-stop' }, 6)}
                        {inNumber('area_construccion', 2, false, { icon: 'pi pi-home' }, 6)}
                        {inNumber('precio_bien', 2, true, { icon: 'pi pi-dollar' }, 6)}
                        {inNumber('valor_cuota_entrada', 2, true, { icon: 'pi pi-wallet' }, 6)}
                        {inCalendar('fecha_entrega', { min: true }, 6)}
                        {inNumber('pago_vista', 2, true, { icon: 'pi pi-money-bill' }, 6)}
                        {inNumber('saldo_deuda_inicial', 2, true, { icon: 'pi pi-credit-card' }, 6)}
                        {inNumber('numero_cuotas', 0, false, { icon: 'pi pi-sort-numeric-up' }, 6)}
                        {inCalendar('fecha_primer_pago', { min: true }, 6)}
                        {inNumber('valor_financia_largo_plazo', 2, true, { icon: 'pi pi-chart-line' }, 6)}
                        {inText('banco_financia_largo_plazo', { icon: 'pi pi-building-columns' }, 6)}
                        {inNumber('plazo_financia_credito', 0, false, { icon: 'pi pi-clock' }, 6)}
                        {inNumber('gastos_legales', 2, true, { icon: 'pi pi-briefcase' }, 6)}
                        {inText('responsable_precalificacion', { icon: 'pi pi-user' }, 12)}
                    </div>

                    {soloLectura ? (
                        <div className="flex justify-content-end mt-3">
                            <Button label="Cerrar" icon="pi pi-times" type="button" className="p-button-warning" onClick={() => setDialogInmueble(false)} />
                        </div>
                    ) : (
                        generic.buttonsForms(setDialogInmueble, load)
                    )}
                </form>
            </Dialog>
        </>
    )
}
